module.exports = __webpack_public_path__ + "img/Clay Scofield.8efe9ca6.jpg";